import { imageAlt } from './ImageStore';

import { imageAltDefault } from './ImageStoreDefaults';

export const resetImageAlt = () => {
	imageAlt.set(imageAltDefault);
};
